import React from "react";
import { Link } from "react-router-dom";
import { t, useStoreLanguage } from "../features/store-language/i18n.ts";
import type { ShopTopMenuItem } from "./ShopTopMenu.tsx";

function containsPath(item: ShopTopMenuItem, currentPath: string): boolean {
  if (item.path === currentPath) return true;
  return Boolean(item.children?.some(function (child) {
    return containsPath(child, currentPath);
  }));
}

export default function ShopHeaderNavigation({ items, currentPath }: {
  items: ShopTopMenuItem[];
  currentPath: string;
}) {
  useStoreLanguage();
  return (
    <nav
      className="shop-header-navigation"
      aria-label={t("دسته‌بندی محصولات")}
    >
      <div className="shop-header-navigation__items">
        {items.map(function (item) {
          const active = containsPath(item, currentPath);
          return (
            <Link
              key={item.key}
              to={item.path}
              className={`shop-header-navigation__link${active ? " is-active" : ""}`}
              aria-current={item.path === currentPath ? "page" : undefined}
            >
              {item.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
